import React, { Component } from 'react';
import { createComponent as cc } from 'react-fela';
import { SocialLinks } from './';
import logo from '../assets/logo.svg';
import successIcon from '../assets/ico-success.svg';

import { COLORS } from '../util/constants';

const Logo = cc(_ => ({
  backgroundImage: `url(${logo})`,
  backgroundSize: '370px 370px',
  transform: 'translateY(-40vh) scale(.13)',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  width: '100%',
  height: '100%',
  position: 'absolute',
}));

const ArrowWrapper = cc(_ => ({
  position: 'fixed',
  bottom: 0,
  width: '100%',
  marginBottom: '10vh',
  height: '8vh',
  small: {},
}));

const SuccessLogo = cc(_ => ({
  backgroundImage: `url(${successIcon})`,
  backgroundSize: '100px 100px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  width: '100px',
  height: '100px',
  margin: '9vh auto 4vh',
  small: {
    width: '60px',
    height: '60px',
    backgroundSize: '60px 60px',
    margin: '9vh auto 4vh',
  },
}));

const PageWrapper = cc(_ => ({
  marginTop: '18vh',
}));

const TitleWrapper = cc(_ => ({
  textAlign: 'center',
  height: '30%',
  small: {
    height: '15vh',
  },
}));

const Title = cc(_ => ({
  color: COLORS.GOLD,
  fontSize: '34px',
  margin: '12vh',
  fontWeight: '200',
  small: {
    margin: '12vh 0',
    fontSize: '28px',
    padding: '0 20px',
  },
}));

const SuccessTitle = cc(_ => ({
  color: COLORS.GOLD,
  fontSize: '32px',
  margin: '10vh auto 2vh auto',
  fontWeight: '200',
  small: {
    margin: '10vh auto 2vh auto',
    fontSize: '26px',
    padding: '0 20px',
  },
}));

const SubTitle = cc(_ => ({
  fontSize: '18px',
  marginBottom: '30px',
  fontWeight: '100',
  small: {
    fontSize: '16px',
    padding: '0 20px',
  },
}));

const InputWrapper = cc(_ => ({
  textAlign: 'center',
  height: '33%',
}));

const Banner = cc(_ => ({
  fontSize: '28px',
  textTransform: 'uppercase',
  fontWeight: '300',
  padding: '50px',
  marginBottom: '4vh',
  small: {
    fontSize: '22px',
    marginBottom: '10px',
    padding: '20px',
  },
}));

const EmailInputWrapper = cc(_ => ({
  margin: 'auto',
  width: '50%',
  outline: 'none',
  marginBottom: '50px',
  small: {
    width: '80vw',
    height: '14vw',
    marginBottom: '6vh',
  },
}));

const EmailInput = cc(
  _ => ({
    width: '100%',
    height: '40px',
    border: 'none',
    borderBottom: '1px lightgray solid',
    fontSize: '20px',
    outline: 'none',
    small: {
      fontSize: '16px',
      textAlign: 'center',
    },
  }),
  'input',
  ['type', 'placeholder']
);

const SubmitButton = cc(
  _ => ({
    fontSize: '14px',
    borderRadius: '40px',
    width: '28vw',
    height: '7vh',
    margin: 'auto',
    color: 'white',
    outline: 'none',
    backgroundColor: COLORS.BUTTON,
    border: 'none',
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: 'background-color .5s',
    ':hover': {
      backgroundColor: COLORS.BUTTON_DARK,
    },
    small: {
      fontSize: '12px',
      borderRadius: '10vw',
      width: '80vw',
      height: '15vw',
    },
  }),
  'button',
  ['onClick']
);

const Bold = cc(_ => ({ fontWeight: '600' }), 'span');

const SubscribeWrapper = cc(_ => ({
  backgroundColor: 'white',
  borderRadius: 2,
  display: 'inline-block',
  textAlign: 'center',
  width: '100%',
  height: '100%',
}));

const Message = cc(({ color }) => ({
  color: color,
  fontSize: '12px',
  textAlign: 'left',
  padding: '5px 0',
  height: '20px',
}));

class SubscribeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: false,
      subtitle: false,
      input: false,
      button: false,
      banner: false,
    };
  }

  async componentDidMount() {
    setTimeout(() => {
      this.setState({ title: true });
    }, 0);
    setTimeout(() => {
      this.setState({ input: true });
    }, 400);
    setTimeout(() => {
      this.setState({ button: true });
    }, 600);
  }

  render() {
    const { status, message, onValidated, onSuccess } = this.props;
    const { title, subtitle, input, button, banner } = this.state;

    const submit = () => {
      const email = this.emailInput.value;
      email.indexOf('@') > -1 &&
        onValidated({
          EMAIL: email,
        });
    };

    let textToDisplay = '';

    if (status === 'success') {
      onSuccess(message);
    } else if (status === 'error') {
      if (
        message.includes('is already') ||
        message.includes('has too many recent signup requests')
      ) {
        textToDisplay = 'You are already subscribed.';
      } else {
        textToDisplay = message;
      }
    }

    return (
      <SubscribeWrapper>
        <Logo />
        {status === 'success' && (
          <PageWrapper className='fadeIn'>
            <SuccessLogo />
            <SuccessTitle>Thank you for subscribing</SuccessTitle>
            <SubTitle>You will receive a message when we are online</SubTitle>
          </PageWrapper>
        )}
        {status !== 'success' && (
          <PageWrapper>
            <Title className={ title ? 'fadeIn' : 'hide' }>
              Be <Bold>the first</Bold> to know
            </Title>
            <EmailInputWrapper>
              <EmailInput
                className={ input ? 'fadeIn' : 'hide' }
                innerRef={ node => (this.emailInput = node) }
                type='email'
                placeholder='Enter your e-mail' />
              <Message color={ status === 'error' ? COLORS.ERROR : COLORS.GOLD }>
                {status === 'error' && textToDisplay}
                {status === 'sending' && 'sending...'}
              </Message>
            </EmailInputWrapper>
            <SubmitButton
              className={ button ? 'fadeIn' : 'hide' }
              onClick={ submit }>
              Sign Me Up
            </SubmitButton>
          </PageWrapper>
        )}
        <ArrowWrapper>
          <div className={ 'arrow arrow-first' } />
        </ArrowWrapper>
        <SocialLinks />
      </SubscribeWrapper>
    );
  }
}

export default SubscribeForm;



// WEBPACK FOOTER //
// ./src/components/SubscribeForm.js